import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track12CRed = ({ state, workState, onLabelClick }) => (
	<g id="Track12CRed" transform="translate(2191.000000, 181.000000)" className="track">
		<path
			d="M64.3840329,-9.9475983e-14 L56.3232288,22.7156415 C52.5127482,33.4537157 50.5654605,44.7640345 50.5654605,56.1581558 L50.5654605,97.1354711 C50.5654605,110.165573 48.018935,123.070079 43.0690698,135.123394 L26.2037468,176.191795 M22.1880656,185.970298 L0,240"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		<TrackArrow
			transform="translate(27.152392, 173.727145) rotate(-67.000000) translate(-27.152392, -173.727145) "
			points="31.1523925 181.727145 23.1523925 173.727145 31.1523925 165.727145"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track12CRed')}
			coords="29.289062, 96.869087"
			text="12C"
			textCoordsX="7.8359375"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track12CRed.propTypes = trackPropTypes;

export default Track12CRed;
